module.exports = __webpack_public_path__ + "static/img/8一种切管机的减震结构.4e8b4c0b.jpg";